export function logout() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('disclaimerAccepted')
  localStorage.removeItem('ideya-error')

  const call = (url: string) => {
    return new Promise<void>((resolve) => {
      const newWindow = window.open(url, '_blank', 'width=500,height=500')
      setTimeout(() => {
        if (newWindow) {
          newWindow.close()
        } else {
          console.log('Failed to open new window, trying to redirect instead.')
        }
        resolve()
      }, 5000)
    })
  }

  const logoutUrl = logoutAuth0Url(logoutCloudflareUrl())
  call(`${logoutUrl}`).finally(() => {
    setTimeout(() => {
      location.href = `https://${location.host}`
    }, 100)
  })

  return { type: 'LOGOUT' }
}

function logoutAuth0Url(returnTo: string) {
  return `${import.meta.env.VITE_AUTH0_LOGOUT_URL}?returnTo=${encodeURIComponent(returnTo)}`
}

function logoutCloudflareUrl() {
  return `https://${window.location.host}/cdn-cgi/access/logout`
}
